import { schedules } from '../../../../../api';
import { findNextPendingDriverTicket } from '../../../../../query-hooks/tickets';
import {
  VEHICLE_ID_STORAGE_KEY,
  filterDisplayableAssignments,
  resolveVehicleForLoadAssignments,
} from '../../../../../query-hooks/load-assignments';

const readSavedVehicleId = () => (localStorage?.getItem?.(VEHICLE_ID_STORAGE_KEY) || '').trim?.() || '';

export const fetchLandingInputs = async entityRef => {
  const pendingTicket = await findNextPendingDriverTicket(entityRef);
  if (pendingTicket) {
    return { hasPendingTicket: true };
  }

  const savedVehicleId = readSavedVehicleId();
  if (!savedVehicleId) {
    return { hasPendingTicket: false, savedVehicleId: '' };
  }

  const vehicle = await resolveVehicleForLoadAssignments(entityRef, savedVehicleId);
  const vehicleFound = vehicle?.found === true;
  const matchesLoggedInDriver = vehicle?.matchesLoggedInDriver === true;

  if (!vehicleFound || !matchesLoggedInDriver || !vehicle?.vehicleRef) {
    return {
      hasPendingTicket: false,
      savedVehicleId,
      vehicleFound,
      matchesLoggedInDriver,
      displayableAssignmentCount: 0,
    };
  }

  const assignments = await schedules?.listScheduledLoadAssignments?.({
    entityRef,
    queryParams: {
      dateOption: 'Today',
      vehicleRef: vehicle?.vehicleRef,
      allowAllAggregateOrders: true,
    },
  });

  const displayable = filterDisplayableAssignments(assignments);

  return {
    hasPendingTicket: false,
    savedVehicleId,
    vehicleFound: true,
    matchesLoggedInDriver: true,
    displayableAssignmentCount: displayable?.length ?? 0,
  };
};
